import { Itinerario } from "./itinerario";

export class Turma {
    id?: string;
    nome?: string;
    horarioInicio?: string;
    horarioFim?: string;
    diaSemana?: string;
    idOriginal?: string;
    ano?: number;
    /** Preenchido pela API na listagem de turmas */
    quantidadeMatriculas?: number;
    ativo?: boolean;
    itinerario?: Itinerario | null;
    /** Retornado direto pela API na listagem/edição de turmas */
    itinerarioId?: string | null;

    constructor(data?: Partial<Turma>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
